const API_BASE_URL = '/universalMFA';

export { API_BASE_URL };
